import React from 'react';
import { Plus } from 'lucide-react';
import ConditionEditor from '../ConditionEditor';
import { Condition, FieldType } from '../types';
import { subtleButton } from '../ui';

export function ConditionBlock({ title, value, fields, onChange, action }: { title: string; value?: Condition; fields: { key: string; label: string; type: FieldType }[]; onChange: (v?: Condition) => void; action?: React.ReactNode }) {
  const addCondition = () => {
    const next = { field: fields[0]?.key || '', operator: 'equals' as const, value: '' };
    if (!value) return onChange(next);
    const groupKey = (['all', 'any', 'none', 'one', 'not'] as const).find((key) => Array.isArray(value[key]));
    if (groupKey) {
      const children = (value[groupKey] || []) as Condition[];
      if (groupKey === 'not') return onChange({ all: [value, next] });
      return onChange({ ...value, [groupKey]: [...children, next] });
    }
    onChange({ all: [value, next] });
  };
  return <div className="mb-4 last:mb-0"><div className="mb-1.5 flex items-center justify-between gap-2"><div className="text-[11px] font-semibold text-slate-600">{title}</div><div className="flex items-center gap-1.5">{action}{value && <button type="button" className={subtleButton} onClick={addCondition}><Plus className="h-3.5 w-3.5" /> Add condition</button>}</div></div>{value ? <ConditionEditor fields={fields} value={value} onChange={onChange} /> : <button type="button" className="inline-flex h-8 items-center gap-1.5 rounded-lg border border-dashed border-slate-300 px-2.5 text-[11px] font-medium text-slate-500 transition hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700" onClick={addCondition}><Plus className="h-3.5 w-3.5" /> Add condition</button>}</div>;
}

export default ConditionBlock;
